import React from 'react'
import Router from './routers'
import store from '@/store'
import { setCategories } from '@/store/actions'
import API from '@/api'

class BackgroupComponent extends React.Component {
  constructor (props) {
    super(props)
  }

  getCategory = async function () {
    const res = await API.GetCategory()
    if (res.code !== 200) return []
    return res.result
  }

  async componentDidMount () {
    const defaultCategories = await this.getCategory()
    store.dispatch(setCategories(defaultCategories))
  }

  render () {
    return (
      <div>
        <Router />
      </div>
    )
  }
}

export default BackgroupComponent